/**
 * ESC fecha a conversa como no Chat do ERP: primeiro o que está por cima,
 * depois a conversa.
 *
 * 1. Diálogo aberto (confirmação, passo extra de MFA): o ESC é dele.
 * 2. Popover, prévia flutuante, dica: fecham sozinhos e marcam o evento
 *    (`preventDefault`); este ouvinte espera eles rodarem e não faz nada.
 * 3. Citação em andamento: o ESC só a cancela.
 * 4. Áudio gravando ou gravado sem mandar: pede confirmação (sair descarta).
 * 5. Nada disso: volta para a lista (o rascunho fica guardado).
 *
 * Campo de busca com texto: o ESC limpa a busca, não sai da conversa.
 */
import { useEffect, useRef } from "react";

const CAMADA_MODAL = '[role="alertdialog"], [aria-modal="true"]';

function haCamadaModal() {
  return Boolean(document.querySelector(CAMADA_MODAL));
}

function buscaComTexto(alvo) {
  return alvo instanceof HTMLInputElement && alvo.type === "search" && alvo.value !== "";
}

export default function useEscParaSair({ ativo, citando, aoCancelarCitacao, comAudio, aoConfirmarSaida, aoSair }) {
  const atual = useRef(null);
  atual.current = { citando, aoCancelarCitacao, comAudio, aoConfirmarSaida, aoSair };

  useEffect(() => {
    if (!ativo) return undefined;
    const aoTeclar = (evento) => {
      if (evento.key !== "Escape" || evento.defaultPrevented || evento.isComposing) return;
      if (haCamadaModal() || buscaComTexto(evento.target)) return;
      // Os popovers escutam no mesmo documento e podem ter se inscrito depois
      // deste ouvinte: espera todos rodarem antes de decidir.
      window.setTimeout(() => {
        if (evento.defaultPrevented) return;
        const estado = atual.current;
        if (estado.citando) estado.aoCancelarCitacao();
        else if (estado.comAudio) estado.aoConfirmarSaida();
        else estado.aoSair();
      }, 0);
    };
    document.addEventListener("keydown", aoTeclar);
    return () => document.removeEventListener("keydown", aoTeclar);
  }, [ativo]);
}
